import {
  GlobeFillIcon,
  PaperFillIcon,
  PenFillIcon,
  YoutubeFillIcon,
} from '@zep-us/zus-icons';

/** 도구 줄 자료 아이콘 — 고른 것만 보라, 나머지는 회색(색은 쓰는 곳에서 정한다). */
export const AI_GENERATE_DOCK_SOURCE_ICON = {
  query: PenFillIcon,
  file: PaperFillIcon,
  youtube: YoutubeFillIcon,
  website: GlobeFillIcon,
} as const;
